import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/ekrammd/Documents/GitHub/edutechs-live-video-streaming-client/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/Users/ekrammd/Documents/GitHub/edutechs-live-video-streaming-client/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/ekrammd/Documents/GitHub/edutechs-live-video-streaming-client/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/Users/ekrammd/Documents/GitHub/edutechs-live-video-streaming-client/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
